module.exports = __webpack_public_path__ + "static/media/cjclogosmall.c1e3060e.png";